import { Link } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';
import { motion } from 'framer-motion';

const OrderSuccessPage = () => {
  return (
    <div className="min-h-screen pt-20 flex items-center justify-center" data-testid="order-success-page">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        className="text-center max-w-md"
      >
        <div className="w-20 h-20 bg-brand-green rounded-full flex items-center justify-center mx-auto mb-6">
          <CheckCircle className="w-12 h-12 text-white" />
        </div>
        <h1 className="text-3xl font-heading font-bold text-brand-pearl mb-4" data-testid="success-heading">
          Order Placed Successfully!
        </h1>
        <p className="text-brand-walnut mb-8">
          Thank you for your purchase. You will receive an order confirmation email shortly.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/shop"
            data-testid="continue-shopping-success-btn"
            className="inline-flex items-center justify-center px-8 py-3 bg-brand-pearl text-brand-ivory font-medium rounded-sm hover:bg-brand-walnut transition-colors"
          >
            Continue Shopping
          </Link>
          <Link
            to="/"
            data-testid="back-home-btn"
            className="inline-flex items-center justify-center px-8 py-3 border-2 border-brand-pearl text-brand-pearl font-medium rounded-sm hover:bg-brand-pearl hover:text-brand-ivory transition-colors"
          >
            Back to Home
          </Link>
        </div>
      </motion.div>
    </div>
  );
};

export default OrderSuccessPage;